const path = require('path')

const router = require('../../router')


module.exports = (graphql, actions, route) => {
  const { createPage } = actions
  const gameOverloadContainer = path.resolve('src/containers/GameOverload/index.js')

  return createPage({
    path: router(route.path, {}),
    component: gameOverloadContainer,
    context: {
      isVip: !!route.isVip,
    },
  })
}
